export default __webpack_public_path__ + "static/media/iStock-1032613564B2.54c23098.jpg";